import * as moment from 'moment';
import { IDatePickerDates } from './IDatePickerDates';

export class DateRange {
    beginDateTime: string;
    endDateTime: string;
    comment: string;
    keyword: string;
    timeZone: string;
    guid: string;
}

export interface IDateRange {
    beginDate: moment.Moment;
    endDate: moment.Moment;
}

// TODO: Standardize IStringDateRange once and for all!!!

export interface IStringDateRange {
    startDate: string;
    endDate: string;
}

export interface IStringDateRange2 {
    beginDate: string;
    endDate: string;
}

export interface IDateDateRange {
    beginDate: Date;
    endDate: Date;
}

export const toDatePickerDates = (input: IStringDateRange2): IDatePickerDates => {
    return { startDate: moment(input.beginDate), endDate: moment(input.endDate) };
};